// @flow
import * as types from '../constants/action_types'

const setFetchingState = (isFetching: boolean) =>
    ({ type: types.SET_FETCHING_STATE, isFetching })

const setFetchedState = (isFetched: boolean, state: { token?: { value: string } }) =>
    ({ type: types.SET_FETCHED_STATE, isFetched, state })

const updateMeta = (name: string, version: string, user: {}) => ({ type: types.UPDATE_META, name, version, user })

// Fetches server state, e.g. to initialize the application.
export const fetchState = (location: { params: { token: string, value: string} }) => (dispatch: Function, getState: Function) => {
    let fetchError = false
    const token = location.params.token ? location.params.token : getState().token.value
    const query = token ? `?token=${token}` : ''
    dispatch(setFetchingState(true))
    fetch(`/${getState().meta.name}/api/v1/state/${query}`).then((response) => {
        fetchError = !response.ok
        return response.json()
    }).then((json) => {
        dispatch(setFetchingState(false))
        if (fetchError) {
            dispatch(setFetchedState(true, { exception: json.exception }))
        } else {
            dispatch(setFetchedState(true, json.state))
            dispatch(updateMeta(json.meta.name, json.meta.version, json.meta.user))
        }
    })
}

export const updateAppState = (which, fnSaved) => (dispatch, getState) => {
    const newState = {
        appState: {
            [which]: getState()[which],
        },
    }
    const body = JSON.stringify(newState)
    fetch(`/${getState().meta.name}/api/v1/state/?token=${getState().token.value}`,
        {
            body,
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        .then((ret) => {
            if (fnSaved) fnSaved()
        })
        .catch(ret => alert(ret))
}

export const onLogout = () => (dispatch, getState) => {
    fetch(`/${getState().meta.name}/logout/?token=${getState().token.value}`,
        {
            method: 'POST',
        })
}
